import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
    FaIconLibrary,
    FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import {
    faSpinner,
    faCheck,
    faExclamation,
    faMapPin,
    faTimes,
    faHistory,
} from '@fortawesome/pro-regular-svg-icons';
import { MomentModule } from 'ngx-moment';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { ObjectToKVPPipe } from '@qwyk/ui-standalone';

import { SharedModule } from '../shared/shared.module';
import {
    LocationTypeaheadItemDirective,
    LocationTypeaheadHintDirective,
    LocationTypeaheadPlaceholderDirective,
    LocationTypeaheadNotFoundDirective,
} from './components/location-typeahead/location-typeahead-templates.directive';
import { GooglePlacesDirective } from './directives/google-places.directive';
import { StateButtonComponent } from './components/state-button/state-button.component';
import { DimensionsDialogComponent } from './components/dimensions-dialog/dimensions-dialog.component';
import { LocationTypeaheadComponent } from './components/location-typeahead/location-typeahead.component';
import { LocationTypeaheadPanelComponent } from './components/location-typeahead/location-typeahead-panel.component';

@NgModule({
    declarations: [
        StateButtonComponent,
        LocationTypeaheadComponent,
        LocationTypeaheadPanelComponent,
        LocationTypeaheadItemDirective,
        LocationTypeaheadPlaceholderDirective,
        LocationTypeaheadHintDirective,
        LocationTypeaheadNotFoundDirective,
        GooglePlacesDirective,
        DimensionsDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        MomentModule,
        ObjectToKVPPipe,
        TranslateModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        DynamicDialogModule,
    ],
    exports: [
        StateButtonComponent,
        GooglePlacesDirective,
        LocationTypeaheadComponent,
        LocationTypeaheadItemDirective,
        LocationTypeaheadHintDirective,
        LocationTypeaheadNotFoundDirective,
        LocationTypeaheadPlaceholderDirective,
    ],
})
export class ControlsModule {
    constructor(private library: FaIconLibrary) {
        library.addIcons(
            faSpinner,
            faCheck,
            faExclamation,
            faMapPin,
            faTimes,
            faHistory
        );
    }
}
